import { render, staticRenderFns } from "./CodeEqual.vue?vue&type=template&id=b22339c2"
import script from "./CodeEqual.vue?vue&type=script&lang=js"
export * from "./CodeEqual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports